@@ -1,34 +0,0 @@
<template>
    <div />
</template>

<script lang="ts" setup>
import get from 'lodash-es/get'

onMounted(async () => {
  const route = useRoute()
  const token: string = String(route.query.token) || ''
  const config = useRuntimeConfig().public
  const workspaceId = get(config, 'workspaceId', '') as string

  const api = $urlPartner.customer.customerAccept
  api.headers.tokenInvite = token

  const res = await $api(api)
  const data: any = res.data.value
  if (data) {
    process.client && $toast().success(data.data)
    return navigateTo({
      name: 'c-id-dashboard',
      params: { id: workspaceId }
    })
  } else {
    return navigateTo({
      name: 'c-id-dashboard',
      params: { id: workspaceId }
    })
  }
})
</script>
